<template>
  <div>
    <ul class="content">
      <h2 class="title">News</h2>
      <li
        id="app-modal"
        class="content__item"
        v-for="(item,index) in articles"
        :key="item.postId"
        @click="onSelect(item)"
      >
        <div v-if="index===0">
          <div class="content__date">
            <span>{{item.date}}</span>
          </div>
          <div class="content__detailTitle">
            <div class="content__detailLocation">{{item.title}}</div>
          </div>
          <pre class="content__detail">{{item.outline}}</pre>
          <div v-if="item.image !== ''" class="content__detail">
            <img :src="item.image" width="200px" height="auto" />
          </div>
          <pre class="content__detail">{{item.detail}}</pre>
          <div v-if="item.youtube !== '' || item.youtube !== undefined" class="content__detail">
            <YoutubeContainer :id="item.youtube" />
          </div>
        </div>
        <div v-if="index!==0">
          <div class="content__date">
            <span>{{item.date}}</span>
          </div>
          <div class="content__detailTitle">
            <div class="content__detailLocation">{{item.title}}</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import YoutubeContainer from "../components/YoutubeContainer";
import { getAllArticles } from "../functions/articles-function";

export default {
  name: "news",
  data() {
    return {
      postId: 0,
      articles: []
    };
  },
  components: {
    YoutubeContainer
  },
  mounted: async function() {
    this.articles = await getAllArticles();
  },
  methods: {
    onSelect: function(item) {
      this.$router.push({
        name: "article",
        params: { id: item.postId.toString() }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
pre {
  white-space: pre-wrap; /* CSS3 */
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -webkit-pre-wrap; /* Chrome, Safari */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* IE 5.5+ */
}

.title {
  margin-top: 30px;
  padding-left: 40%;

  font-size: 1.2rem;
  font-family: "discoregular";
  font-weight: normal;
  letter-spacing: 0.1rem;
  margin: 0;
}

.content {
  font-family: "discoregular";

  list-style-type: none;
  padding: 0;
  margin-top: 30px;
  margin-bottom: 30px;

  &__item {
    position: relative;
    display: flex;
    border-bottom: 1px solid black;
    padding: 15px;
  }

  &__hoveredItem {
    position: relative;
    display: flex;
    border-bottom: 1px solid black;
    padding: 15px;
  }

  &__detail {
    margin-right: auto;
    margin: 15px;
    font-size: 0.9rem;
  }
  &__detailTitle {
    margin-top: 15px;
    font-size: 1.2rem;
    font-size: 1.3rem;
  }
  &__date {
    padding-right: 22px;
    h3 {
      margin: 0;
    }
  }
}

.description {
  margin: 10px 15px 0 0;
  text-align: end;
  span {
    padding-left: 5px;
    font-size: 13px;
  }
}

@media screen and (max-width: 480px) {
  .v-card__title {
    padding: 10px 0;
  }
  .description {
    text-align: start;
  }
  .content {
    &__item {
      display: block;
    }
    &__date {
      width: auto;
      padding-right: 0;
      margin-bottom: 10px;
    }
  }
}

/* popup modal */
</style>
